export class UserImageRequestModel {
  Base64Image: string | ArrayBuffer | null;

  constructor() { }
}
